import {API_VERSIONS} from './api/maps-api-common';

export const defaultClassicCredentials = {
  apiKey: 'default_public',
  region: 'us',
  username: 'public'
};

export const defaultCloudNativeCredentials = {
  apiBaseUrl: 'https://gcp-us-east1.api.carto.com'
};

export interface ClassicCredentials {
  apiVersion: string;
  apiKey: string;
  region: string;
  username: string;
  mapsUrl?: string;
}

export interface CloudNativeCredentials {
  apiVersion: string;
  apiBaseUrl: string;
  accessToken?: string;
  mapsUrl?: string;
}

export type Credentials = ClassicCredentials | CloudNativeCredentials;
let credentials: Credentials = {} as Credentials;

// @ts-ignore
setDefaultCredentials({});

// @ts-ignore
export function setDefaultCredentials({apiVersion, ...rest}: any) {
  // @ts-ignore
  apiVersion = apiVersion || API_VERSIONS.V3;

  credentials = {apiVersion, ...defaultCloudNativeCredentials, ...rest};
}

export function getDefaultCredentials(): Credentials {
  return credentials;
}

export type V3Endpoint = 'maps' | 'stats';

function buildUrlFromBase(apiBaseUrl: string, endpoint: V3Endpoint) {
  let suffix = `/v3/${endpoint}`;
  if (apiBaseUrl.endsWith('/')) {
    suffix = suffix.substring(1);
  }

  return `${apiBaseUrl}${suffix}`;
}

export function buildMapsUrlFromBase(apiBaseUrl: string): string {
  return buildUrlFromBase(apiBaseUrl, 'maps');
}

export function buildStatsUrlFromBase(apiBaseUrl: string): string {
  return buildUrlFromBase(apiBaseUrl, 'stats');
}



// WEBPACK FOOTER //
// ./src/app/common/services/fetch-layer-data/config.ts